import { HttpRequest } from '@angular/common/http';
import { InjectionToken } from '@angular/core';
import { API_ENDPOINT } from '@core/configs';

export const INTERCEPTOR_EXCEPT_URL: Array<string | RegExp> = [
  API_ENDPOINT.auth.loginByCKPass,
  location.origin,
  /^(?![a-z+]+:\/\/)/g,
];

export const AUTH_TOKEN_INTERCEPTOR_FILTER =
  new InjectionToken<(req: HttpRequest<any>) => boolean>('Interceptor Filter');
